import {HTMLAttributes} from 'react';
import {DisplayAdContainer} from '../../../common/containers/DisplayAdContainer/DisplayAdContainer';
import {twMerge} from '../../../common/twMerge';
import {DisplayAd, Maybe, SaleState} from '../../../graphql/generated/types';

export function ContentHomeTabWrapper({
  displayAd,
  saleState = SaleState.Unknown,
  isMobile,
  children,
  className,
  ...props
}: {
  isMobile: boolean;
  displayAd?: Maybe<DisplayAd>;
  saleState?: Maybe<SaleState>;
} & HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      {...props}
      className={twMerge(
        'flex flex-1 flex-col',
        isMobile && 'pt-4pxr pb-32pxr',
        className
      )}
    >
      {saleState === SaleState.Ing && isMobile && displayAd && (
        <div className="px-11pxr">
          <DisplayAdContainer displayAd={displayAd} />
        </div>
      )}
      {children}
    </div>
  );
}
